
import React, { useEffect, useState } from 'react';
import SplashScreen from '../SplashScreen';

const AppSplashScreen = ({ children }) => {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 1200); // Splash sempre por 1.2s
    return () => clearTimeout(timer);
  }, []);

  if (showSplash) {
    return (
      <SplashScreen message="Carregando..." onHide={() => setShowSplash(false)} />
    );
  }
  return children;
};

export default AppSplashScreen;
